/** @format */
import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header, Footer } from '../components';
import FloatingButton from '../components/common/FloatingButtton/FloatingButton';

const PublicLayout = () => {
  const { pathname } = useLocation();
  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleScroll = () => {
      const currentScrollPos = window.scrollY;
      setVisible(currentScrollPos < 10 || prevScrollPos > currentScrollPos);
      setPrevScrollPos(currentScrollPos);
    };

    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, [prevScrollPos, visible]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="w-full mx-auto h-full">
      <div className="w-full relative">
        {/* Header */}
        <header
          className={`sticky top-0 z-10 w-full transition-all duration-300 
          ${visible ? 'visible' : 'invisible'}
          ${visible ? 'opacity-100' : 'opacity-0'}
          `}
        >
          <Header />
        </header>

        {/* Content */}
        <Outlet />

        {/* Footer */}
        <Footer />

        {/* Floating Button */}
        <FloatingButton />
      </div>
    </div>
  );
};

export default PublicLayout;
